
import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { NavController,ViewController, ModalController ,Content} from 'ionic-angular';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { ConfigProvider } from '../../providers/config/config';
import { TranslateService } from '@ngx-translate/core';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { trigger, style, animate, transition } from '@angular/animations';
import { SubCategories6Page } from '../sub-categories6/sub-categories6';
import { CartPage } from '../cart/cart';
import { SearchPage } from '../search/search';
import { LoadingProvider } from '../../providers/loading/loading';

import Highcharts from 'highcharts';
import Highcharts3d from 'highcharts/highcharts-3d';
import Cylinder from 'highcharts/modules/cylinder';
import Funnel from 'highcharts/modules/funnel3d';
Highcharts3d(Highcharts);
Cylinder(Highcharts);
Funnel(Highcharts);
//var url = 'http://localhost:5001/getcustomers/us-central1/';
var url = 'https://us-central1-getcustomers.cloudfunctions.net/'

@Component({
  selector: 'page-home5',
  animations: [
    trigger(
      'animate', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('700ms', style({ opacity: 0 }))
        ])
      ]
    )
  ],
  templateUrl: 'home5.html',
})

export class Home5Page {
  @ViewChild("barCanvas") barCanvas: ElementRef;
  chosenPipeline = new Array;
  Availablepipeline = new Array;
  FunnelData = new Array;
  dateRange = 6;
  dashboard = {};
  constructor(
    public http: Http,
    public navCtrl: NavController,
    public config: ConfigProvider,
    public viewCtrl: ViewController,
    public modalCtrl: ModalController,
    public loading: LoadingProvider,
    public shared: SharedDataProvider,

  ) {}

    ionViewDidLoad()  {
      this.getPipelines();






        }

        getFunnelDetails(){



          var dataToPost = { "ghl_token":this.shared.customerData.ghl_token, "pipeline_id":this.chosenPipeline,"timeFrame": this.dateRange};
          this.http.post(url + "getFunnelDetails", dataToPost).map(res => res.json()).subscribe(data => {
            console.log("Funnel:",data);

              this.FunnelData = (<any>Object).entries(data);
              //Sales salesfunnel
              var salesfunnel = Highcharts.chart('salesfunnel', {
                chart: {
                  type: 'funnel3d',
                  options3d: {
                      enabled: true,
                      alpha: 10,
                      depth: 50,
                      viewDistance: 50
                  }
              },
              colorAxis: [{}, {
              minColor: '#434348',
              maxColor: '#e6ebf5'
            }],
                        title: {
                  text: 'Sales Funnel'
              },
              legend: {
        enabled: true
    },
              plotOptions: {
                  series: {
                      colorKey: 'y',
                      animation:{duration:1000},
                      dataLabels: {
                          enabled: true,
                          format: '{point.name} ({point.y:,.0f})',
                          allowOverlap: false,
                          y: 0
                      },

                  }
              },
              series: [{
                  name: 'Pipeline Stage',
                  type:undefined,
                  data: this.FunnelData,

              }]
            });
              //End Salesfunnel
          });

        }

        getPipelines(){


          var data: { [k: string]: any }
          this.http.get(this.config.url + 'getPipelines?ghl_token=' +this.shared.customerData.ghl_token).map(res => res.json()).subscribe(data => {
            this.loading.hide();
            if (data.success == 1) {
              this.Availablepipeline = data.pipelines.pipelines;
              console.log("Pipelines:",data.pipelines.pipelines);
              this.chosenPipeline = this.Availablepipeline[0].id;
              this.getFunnelDetails();
              var dataToPost = { "ghl_token":this.shared.customerData.ghl_token, "pipeline_id":this.chosenPipeline,"timeFrame": this.dateRange};
              this.http.post(url + "getOppsinPipeline", dataToPost).map(res => res.json()).subscribe(data => {
                console.log("Dashboard:",data);
                this.dashboard = data;
              });


              }
            });


        }
        SelectDateRange(){
          console.log("Select Pipeline Stage for :" , this.chosenPipeline);
          console.log("Date Range :" , this.dateRange);
          var currentDate = (new Date).getTime();

          this.getFunnelDetails();
          var dataToPost = { "ghl_token":this.shared.customerData.ghl_token, "pipeline_id":this.chosenPipeline,};
          this.http.post(url + "getOppsinPipeline", dataToPost).map(res => res.json()).subscribe(data => {
            console.log("Dashboard:",data);
            this.dashboard = data;
          });
        }

      }



// WEBPACK FOOTER //
// ./src/pages/home5/home5.ts